export function randomInt(int: number): number {
  return Math.floor(Math.random() * Math.floor(int))
}
